import { removeHighlights } from '../../styles';
import { CONTROLS_BAR_HEIGHT } from '../../../../common/utils/common.constants';
import { PlayerSizesTypes } from '../../../../common/store/store.types';

interface StylesObject {
  bottomControlsWrapperStyle: { [key: string]: any }[];
  topControlsWrapperStyle: { [key: string]: any }[];
}

const bottomControlsWrapper = {
  position: 'absolute',
  bottom: 0,
  width: '100%',
  transition: 'all 0.5s ease-in-out',
  opacity: '1',
  transform: 'translateY(0)',
  hide: {
    transform: `translateY(${CONTROLS_BAR_HEIGHT}px)`,
  },
  recirculationVideo: {
    opacity: '0',
    display: {
      opacity: '1',
    },
  },
};
const topControlsWrapper = {
  position: 'absolute',
  top: 0,
  width: '100%',
  transition: 'all 0.5s ease-in-out',
  opacity: 1,
  recirculationsWrapper: {
    background: 'linear-gradient(rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.2) 55%, rgba(0, 0, 0, 0.05) 80%, rgba(0, 0, 0, 0) 100%)',
    medium: {
      height: '66px',
      transform: 'translateY(0)',
    },
    largeAndExtraLarge: {
      height: '100px',
      transform: 'translateY(0)',
    },
    hide: {
      medium: {
        transform: 'translateY(-66px)',
      },
      largeAndExtraLarge: {
        transform: 'translateY(-100px)',
      },
    },
  },
};

export const getFullVideoControlsStyleObject = (isVisible: boolean, playerSize: PlayerSizesTypes, isRecirculationVideo: boolean, showStoriesSeekBars: boolean, showAdControls: boolean, videoLoading: boolean): StylesObject => {
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return {
    bottomControlsWrapperStyle: [
      removeHighlights,
      bottomControlsWrapper,
      !isVisible && (videoLoading || showAdControls || !isRecirculationVideo) && bottomControlsWrapper.hide,
      !isVisible && isRecirculationVideo && !showAdControls && bottomControlsWrapper.recirculationVideo,
      isVisible && showStoriesSeekBars && bottomControlsWrapper.recirculationVideo.display,
    ],
    topControlsWrapperStyle: [
      removeHighlights,
      topControlsWrapper,
      isRecirculationVideo && mediumSize && topControlsWrapper.recirculationsWrapper.hide.medium,
      isRecirculationVideo && (largeSize || extraLargeSize) && topControlsWrapper.recirculationsWrapper.hide.largeAndExtraLarge,
      showStoriesSeekBars && topControlsWrapper.recirculationsWrapper,
      showStoriesSeekBars && mediumSize && topControlsWrapper.recirculationsWrapper.medium,
      showStoriesSeekBars && (largeSize || extraLargeSize) && topControlsWrapper.recirculationsWrapper.largeAndExtraLarge,
    ],
  };
};
